<template>
    <div class="locale-flag">
        <img
            class="locale-flag__img"
            :alt="locale.territory.toUpperCase()"
            v-if="url"
            :src="url"
            @error="setFallbackUrl"
        />

        <div
            class="locale-flag__label"
            :class="{
                'locale-flag__label__short': size === 'short',
                'locale-flag__label__medium': size !== 'short' && size !== 'long',
                'locale-flag__label__long': size === 'long',
                'locale-flag__label__align-left': alignLeft,
             }"
        >
            <div
                class="locale-flag__label__part locale-flag__label__part__short ot-text-tiny-strong"
                v-if="size === 'short'"
            >{{ locale.language.toLowerCase() }}-{{ locale.territory.toUpperCase() }}</div>
            <div
                class="locale-flag__label__part locale-flag__label__language"
                v-if="size !== 'short'"
            >{{ locale.languageDisplayName }}</div><div
                class="locale-flag__label__part locale-flag__label__territory"
                v-if="size !== 'short'"
            >{{ locale.territoryDisplayName }}</div>
        </div>
    </div>
</template>

<script lang="ts">
import type { GlobalizeLocaleInfo } from '@openticket/vue-localization';
import {
    Component,
    Prop,
    Vue,
    Watch,
} from 'vue-property-decorator';

@Component
export default class OtLocaleFlag extends Vue {

    @Prop({ required: true })
        locale!: GlobalizeLocaleInfo;

    @Prop({ default: 'medium' })
        size!: 'long' | 'medium' | 'short';

    @Prop({ default: false, type: Boolean })
        alignLeft!: boolean;

    url = '';

    get prefix(): string {
        if (!this.$localization.flagsUrlPrefix) {
            return '';
        }

        return this.$localization.flagsUrlPrefix.replace(/\/*$/, '');
    }

    @Watch('$localization.initialized')
    localizationInitialized(): void {
        this.setFlagUrl();
    }

    @Watch('locale.flagUrl', { immediate: true })
    flagUrlChanged(): void {
        this.setFlagUrl();
    }

    setFlagUrl(): void {
        if (!this.prefix) {
            this.url = '';

            return;
        }

        this.url = `${this.prefix}/${this.locale.flagUrl}`;
    }

    setFallbackUrl(): void {
        if (!this.prefix) {
            this.url = '';

            return;
        }

        this.url = `${this.prefix}/flags/fallback.svg`;
    }

}
</script>

<style scoped>
.locale-flag {
    display: flex;
    align-items: center;
    text-align: initial;
}

.locale-flag, .locale-flag * {
    box-sizing: border-box;
}

.locale-flag__img {
    height: 1.125rem;
}

.locale-flag__label {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-end;
    flex-grow: 1;

    font-size: .6875rem;
    line-height: .6875rem;
    vertical-align: top;
}

.locale-flag__label .locale-flag__label__territory {
    opacity: 0.5;

    font-size: .5625rem;
    line-height: .5625rem;
    vertical-align: bottom;
}

.locale-flag__label .locale-flag__label__part {
    position: relative;
    display: inline-block;

    padding-left: 0.75rem;
    text-align: right;
}

.locale-flag__label.locale-flag__label__align-left {
    align-items: flex-start;
}

.locale-flag__label.locale-flag__label__align-left .locale-flag__label__part {
    text-align: left;
}

.locale-flag__label.locale-flag__label__short {
    flex-direction: row;
}

.locale-flag__label.locale-flag__label__long {
    display: block;
}

.locale-flag__label.locale-flag__label__long .locale-flag__label__part {
    min-width: 50%;
}

@media (max-width: 25rem) {
    .locale-flag__label {
        display: flex;
    }

    .locale-flag__label.locale-flag__label__long {
        display: flex;
    }
}
</style>
